<template>
  <div>
    <CarouselHome class="home-carrousel" />
    <div class="brief-summary">
      <div class="title">
        Discover the New Zealand's endemic trees & flowers
      </div>
      <p>
        Welcome everyone! I've create this blog
        <strong>BeLeafinTrees</strong> to share my passion of flowers and
        plants. All plants displayed here have been photographied in New Zealand
        parks, gardens and fields. Some are not native don't be surprised if you
        find some of them in your area !
      </p>
      <p>
        About 10-15% of the total land area of New Zealand is covered with
        native flora, from tall kauri and kohekohe forests to rainforest
        dominated by rimu, beech, tawa, matai and rata; ferns and flax;
        dunelands with their spinifex and pingao; alpine and subalpine herb
        fields; and scrub and tussock.
      </p>
    </div>
    <PanelHome />
  </div>
</template>
<script>
import CarouselHome from "./HomeCarousel.vue";
import PanelHome from "./HomePanel.vue";

export default {
  name: "HomePage",
  components: {
    CarouselHome,
    PanelHome,
  },
};
</script>
<style lang="scss" scoped>
.home-carrousel {
  display: none;
  @media (min-width: $constraint-width-medium) {
    display: block;
  }
}
.brief-summary {
  margin: $spacing-small;
}
.title {
  margin: 0;
  font-size: 24px;
  line-height: 1.25;
  text-align: center;
  font-weight: 700;
  @media (min-width: $constraint-width-small) {
    margin: 12px;
  }
}
.subtitle {
  font-size: 14px;
}
</style>
